/**
 * @file
 * @author zhousheng
 */
import React, { useContext, useMemo } from 'react';
import classnames from 'classnames';
import { isValidElement, cloneElement } from '../_util/reactNode';
import Tooltip from '../tooltip';
import MenuContext from './MenuContext';
import { MenuContext as BaseMenuContext } from './rc-menu/context/MenuContext';
;
const MenuHead = props => {
    const { children, icon, title, popupClassName, onClick } = props;
    const { prefixCls } = useContext(MenuContext);
    const { inlineCollapsed } = useContext(BaseMenuContext);
    const classNames = classnames(`${prefixCls}-inline-header`, {
        [`${prefixCls}-inline-header-collapsed`]: inlineCollapsed
    });
    const tipTitle = useMemo(() => {
        if (title) {
            return title;
        }
        if (inlineCollapsed && children) {
            return children;
        }
        return null;
    }, [title, inlineCollapsed, children]);
    const renderNode = useMemo(() => {
        var _a;
        const copyIcon = cloneElement(icon, {
            className: classnames(isValidElement(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : '', `${prefixCls}-item-icon`)
        });
        if (!inlineCollapsed) {
            return (<>{copyIcon}<span className={`${prefixCls}-inline-header-item-text`}>{children}</span></>);
        }
        if (icon) {
            return copyIcon;
        }
        if (typeof children === 'string' && children.length) {
            return <span>{children.charAt(0)}</span>;
        }
        return null;
    }, [inlineCollapsed, children, icon, prefixCls]);
    return (<div className={classNames} onClick={onClick}>
        <Tooltip title={tipTitle} placement="right" overlayClassName={classnames(`${prefixCls}-inline-header-tooltip`, popupClassName)}>
            <div className={`${prefixCls}-inline-header-item`}>{renderNode}</div>
        </Tooltip>
    </div>);
};
export default MenuHead;
